export class DatosCasilla {
   public serviceUrl: string;
   public authenticationType: number;
   public inputHost: string;
   public inputPort: number;
   public inputSSL: boolean;
   public user: string;
   public password: string;
   public clientId: string;
   public clientSecrets: string;
   public credentialFilePath: string;
}
